import { createAction, props } from '@ngrx/store';
import { Theme } from '../../enums/theme.enum';

export const toggleSidenav = createAction('[Config/STORAGE] Toggle Sidenav');

export const openSidenav = createAction('[Config/STORAGE] Open Sidenav');

export const closeSidenav = createAction('[Config/STORAGE] Close Sidenav');

export const toggleTheme = createAction('[Config/STORAGE] Toggle Theme');

export const setTheme = createAction('[Config/STORAGE] Set Theme', props<{ theme: Theme }>());

export const clearConfig = createAction('[Config/STORAGE] Clear Config');

export const skipTos = createAction('[Config/STORAGE] Skip TOS');

export const resetTosSkip = createAction('[Config/STORAGE] Reset TOS Skip');
